import * as _ from "lodash";
import moment from "moment-timezone";
import { getExperimentationGroupIdFromPath } from "../../utils/ManagementGroup/ManagementGroup.utils.js";
const parseError = (r) => {
  var _a, _b, _c;
  const error = (_c = (_a = r == null ? void 0 : r.responseJSON) == null ? void 0 : _a.Error) != null ? _c : (_b = r == null ? void 0 : r.responseJSON) == null ? void 0 : _b.error;
  const apiError = parseVNextApiError(error);
  if (apiError === void 0) {
    return {};
  }
  return {
    displayError: getDisplayError(apiError),
    rawError: apiError,
    typeOfRawError: "IApiError"
  };
};
const parseVNextApiError = (error) => {
  var _a, _b, _c, _d, _e;
  if (typeof error !== "object" || !error) {
    return void 0;
  }
  if (typeof error.code !== "string" && typeof error.Code !== "string" || typeof error.message !== "string" && typeof error.Message !== "string") {
    return void 0;
  }
  return {
    code: (_a = error.code) != null ? _a : error.Code,
    message: (_c = (_b = error == null ? void 0 : error.Message) != null ? _b : error == null ? void 0 : error.message) != null ? _c : "No error information is present",
    target: typeof error.target === "string" || typeof error.Target === "string" ? (_d = error.target) != null ? _d : error.Target : void 0,
    // @ts-ignore
    details: Array.isArray(error.details) || Array.isArray(error.Details) ? _.map((_e = error.details) != null ? _e : error.Details, (d) => parseVNextApiError(d)) : void 0,
    innererror: parseApiInnerError(error)
  };
};
const parseApiInnerError = (error) => {
  var _a, _b, _c;
  const innerError = (_b = (_a = error == null ? void 0 : error.innererror) != null ? _a : error == null ? void 0 : error.innerError) != null ? _b : error == null ? void 0 : error.InnerError;
  if (typeof innerError !== "object" || !innerError) {
    return void 0;
  }
  if (typeof innerError.code !== "string" && typeof innerError.Code !== "string") {
    return void 0;
  }
  return {
    code: (_c = innerError == null ? void 0 : innerError.code) != null ? _c : innerError == null ? void 0 : innerError.Code,
    innerError: parseApiInnerError(innerError)
  };
};
const getDisplayError = (error) => {
  var _a, _b;
  if (((_a = error == null ? void 0 : error.details) == null ? void 0 : _a.length) > 0) {
    return `${error.message}: [${_.map(error.details, (d) => getDisplayError(d)).join(", ")}]`;
  }
  return (_b = error == null ? void 0 : error.message) != null ? _b : "No error information is present";
};
function getDateWithTimezone(dateString) {
  return moment.utc(dateString).tz("America/Los_Angeles").format();
}
const buildFilterString = (workspaceId, filters) => {
  if (!filters) {
    return null;
  }
  const otherSystemQueryOptions = [];
  const filterSystemQueryOptions = [];
  if (filters.fromDateTime && filters.toDateTime) {
    filterSystemQueryOptions.push(
      `Experiments/any(e: e/ExperimentSteps/any(s: s/StartedAt ge ${getDateWithTimezone(
        filters.fromDateTime
      )} and s/StartedAt le ${getDateWithTimezone(filters.toDateTime)}))`
    );
  } else if (filters.fromDateTime) {
    filterSystemQueryOptions.push(
      `Experiments/any(e: e/ExperimentSteps/any(s: s/StartedAt ge ${getDateWithTimezone(filters.fromDateTime)}))`
    );
  } else if (filters.toDateTime) {
    filterSystemQueryOptions.push(
      `Experiments/any(e: e/ExperimentSteps/any(s: s/StartedAt le ${getDateWithTimezone(filters.toDateTime)}))`
    );
  }
  _.each(filters, (value, key) => {
    if (_.includes(["top", "skip", "orderBy"], key)) {
      otherSystemQueryOptions.push(`$${key}=${value}`);
    } else if (_.includes(["fromDateTime", "toDateTime"], key)) {
    } else if (value !== null && value !== void 0) {
      if (key === "isArchived") {
        filterSystemQueryOptions.push(`IsArchived eq ${value}`);
      } else if (key === "experimentationGroup") {
        value = getExperimentationGroupIdFromPath(workspaceId, value.toString());
        filterSystemQueryOptions.push(`(ExperimentationGroup eq '${value}' or startswith(ExperimentationGroup, '${value}~'))`);
      } else if (key === "status") {
        if (value === "new") {
          filterSystemQueryOptions.push(
            `Experiments/all(e: e/ExperimentSteps/all(s: s/StartedAt eq null and s/StoppedAt eq null))`
          );
        } else if (value === "running") {
          filterSystemQueryOptions.push(
            `Experiments/any(e: e/ExperimentSteps/any(s: s/StartedAt ne null and s/StoppedAt eq null))`
          );
        } else if (value === "completed" || value === "stopped") {
          filterSystemQueryOptions.push(
            `Experiments/any(e: e/ExperimentSteps/any(s: s/StartedAt ne null and s/StoppedAt ne null))`
          );
          filterSystemQueryOptions.push(
            `Experiments/all(e: e/ExperimentSteps/all(s: s/StartedAt eq null or s/StoppedAt ne null))`
          );
        }
      } else {
        throw `key '${key}' not supported`;
      }
    }
  });
  const parts = [];
  otherSystemQueryOptions.length && parts.push(otherSystemQueryOptions.join("&"));
  filterSystemQueryOptions.length && parts.push(`$filter=${filterSystemQueryOptions.join(" and ")}`);
  return parts.join("&");
};
export {
  buildFilterString,
  getDisplayError,
  parseApiInnerError,
  parseError,
  parseVNextApiError
};
//# sourceMappingURL=ExpApiV2.utils.js.map
